import {AlertNoticeLevel, EntityAlertType, IAlertInfo} from './IAlertInfo.interface';
import {RiskMatrixLevel} from '../../message-models/risk-matrix-level.enum';

export class AlertInfo implements IAlertInfo {
  constructor(iAlertInfo: IAlertInfo) {
    this.title = iAlertInfo?.title;
    this.detailsHtml = iAlertInfo?.detailsHtml;
    this.canBeDismissed = iAlertInfo?.canBeDismissed;
    this.followUpOn = iAlertInfo?.followUpOn;
    this.directLink = iAlertInfo?.directLink;
    this.alertLevel = iAlertInfo?.alertLevel;
    this.linkText = iAlertInfo?.linkText;
    this.alertType = iAlertInfo?.alertType;
    this.entityId = iAlertInfo?.entityId;
  }

  title: string;
  detailsHtml: string;
  canBeDismissed: boolean;
  directLink: string;
  linkText: string;
  followUpOn: string;
  alertLevel: AlertNoticeLevel;
  alertType: EntityAlertType;
  entityId: string;

  getRiskColour(): string {
    switch (this.alertLevel) {
      case AlertNoticeLevel.Danger:
        return 'red';
      case AlertNoticeLevel.Warning: // TODO Get Alert info colors.
        return 'darkorange';
      case AlertNoticeLevel.Information:
        return 'black';
      case AlertNoticeLevel.Upcoming:
        return 'blue';
    }
    return 'black';
  }
}
